import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BLUE_LIGHT, GRAY_DARKER, GRAY_LIGHT, NEAR_BLACK, WHITE} from 'ui-library/Colors';
import useHoverState from 'ui-library/hooks/useHoverState';

interface ApplicationCardProps {
  onClick: () => void;
  titleText: string;
  bodyText: string;
  imagePath: string;
  buttonText: string;
  hoverOn?: () => void;
  hoverOff?: () => void;
}

export default function SignupScreenCard(props: ApplicationCardProps): JSX.Element {
  const [isHovered, hoverProps] = useHoverState();

  const {onClick, titleText, bodyText, imagePath, buttonText, hoverOn, hoverOff} = props;

  React.useEffect(() => {
    if (hoverOn && isHovered) {
      hoverOn();
    }
    if (hoverOff && !isHovered) {
      hoverOff();
    }
  }, [isHovered, hoverOn, hoverOff]);

  return (
    <div className={classNames(css(styles.container), 'u-pointer')} onClick={onClick} {...hoverProps}>
      <span>
        <img src={imagePath} className={css(styles.image)} />
      </span>
      <span className={classNames('u-flex-grow', css(styles.textBox))}>
        <div className={css(styles.titleText)}>{titleText}</div>
        <div className={classNames(css(styles.bodyText))}>{bodyText}</div>
        <Button
          className={css(styles.button, isHovered && styles.hoverButton)}
          text={buttonText}
          buttonStyle={ButtonStyle.TERTIARY_BLUE}
          size={ButtonSize.MEDIUM}
        />
      </span>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    height: '184px',
    width: '340px',
    border: `1px solid ${GRAY_LIGHT}`,
    borderRadius: '3px',
    display: 'flex',
    justifyContent: 'flex-start',
    ':hover': {
      boxShadow: '0px 2px 6px rgba(162, 185, 190, 0.7);',
    },
  },
  image: {
    height: '100px',
    width: '100px',
    marginLeft: '21px',
    marginTop: '42px',
  },
  textBox: {
    marginTop: '33px',
    marginLeft: '24px',
    marginRight: '16px',
  },
  titleText: {
    fontSize: '18px',
    lineHeight: '24px',
    color: NEAR_BLACK,
  },
  bodyText: {
    fontSize: '12px',
    color: GRAY_DARKER,
    lineHeight: '14px',
    paddingTop: '8px',
  },
  button: {
    marginTop: '8px',
  },
  hoverButton: {
    backgroundColor: BLUE_LIGHT,
    color: WHITE,
  },
});
